import React from "react";
import PropTypes from "prop-types";

import UploadFile from "../../../../containers/Chat/ChatCase/UploadFile";
import "./styles.scss";
import "./style-mobile.scss";

const Modal = ({
															setShowModalRerender,
															setShowModalNoRerender,
															showModalNoRerender,
															showModal,
															idCase,
															}) => {

return (
<>
<UploadFile
idCase={idCase}
setShowModalNoRerender={setShowModalNoRerender}
setShowModalRerender={setShowModalRerender}
showModal={showModal}
/>
<div className="modalBackground"
					onClick={() => showModalNoRerender ? setShowModalNoRerender(false) : null}></div>
</>
);
};

Modal.propTypes = {
setShowModalNoRerender: PropTypes.func,
setShowModalRerender: PropTypes.func,
idCase: PropTypes.string,
showModal: PropTypes.bool,
showModalNoRerender: PropTypes.bool,
};

export default Modal;
